export default "__VITE_ASSET__318f6058__"